import Moment from "moment";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import convertUnicodeEmoji from "../../actions/convertUnicodeEmoji";
import { DetailsAnotationsida } from "../../actions"

let criticData = [];
let anotData = [];
let now                = Moment().subtract(1, "month");
let dateinitsearchanotation = now.format('YYYY-MM-DD');
let dateendsearchanotation = Moment().format("YYYY-MM-DD");

export default function AnotationModal({clientQueueMax}){
    const [visibleCritic, setVisibleCritic] = useState(false);
    const [criticSelected, setCriticSelected] = useState([
        {
            critSelec: 'Todos',
            iconCrit: "",
            idCrit: ""
        }
    ]);
    const CriticalityData = useSelector(state => state.criticalitys);
    const anotationsData = useSelector(state => state.detailsanotations)
    const [buttonLearnMore, setButtonLearnMore] = useState(false);
    const [expandLearn, setExpandLearn] = useState([]);
    const dispatch = useDispatch();

    const SelectCriticitys = (desccriticidade, idcriticidade, tipocriticidade) => {
        setCriticSelected([
            {
            critSelec: desccriticidade,
            iconCrit: tipocriticidade,
            idCrit: idcriticidade
            }
        ]);
        setVisibleCritic(!visibleCritic)
    }

    const checkExpandLearnQueue = (e, idanot) => {
        var checkClick = expandLearn.indexOf(idanot) != -1 ? true : false;
        var temp = [];
    
        if (!checkClick) {
            temp = expandLearn.concat([idanot])
        } else {
            temp = expandLearn.filter(function(val) {
                return val != idanot;
            })
        }
        setExpandLearn(temp)
      }

    const buttonSearchAnotation = (e) => {
        var erro = 0;
        const datainit = document.getElementById('date_init_search').value;
        const datafim = document.getElementById('date_fim_search').value;
        const idcriticidade = criticSelected.length !== 0 ? criticSelected[0].idCrit:"";
    
        let comparation = Moment(datainit).isBefore(datafim);
    
        if (datainit === "") erro = 1;
    
        if (datafim === "") erro = 1;

        if (idcriticidade === 0) erro = 1;
    
        if (comparation === false) {
          erro = 1;
          if (datainit === datafim) {
            erro = 0;
          }
        }
    
        if (erro === 0) {
          dispatch(DetailsAnotationsida(
            datainit,
            datafim,
            idcriticidade,
            clientQueueMax[0].queueCaller
          ));
        }
    }

    if (CriticalityData.length != 0) {
        criticData = CriticalityData.criticalitys;
    }

    if (anotationsData.length != 0) {
        anotData = anotationsData.detailsanotations;
    }
    

    return (
        <div
            className="modal micromodal-slide"
            id="modal__anotacoes_manager_new"
            aria-hidden="true"
            role="dialog"
            >
            <div className="modal__overlay" tabIndex="-1">
                <div
                className="modal__container"
                role="dialog"
                aria-modal="true"
                aria-labelledby="modal__anotacoes__title"
                >
                <header className="modal__header">
                    <h2 className="modal__title" id="modal__anotacoes__title">
                    Anotações
                    </h2>
                    <button
                    className="modal__close"
                    aria-label="Close modal"
                    data-micromodal-close
                    ></button>
                </header>
                <main className="modal__content" id="modal__anotacoes__content">
                    <div className="anotc__info">
                    <p className="anotc__name  is-poppins">
                        {clientQueueMax.length !== 0 ? 
                            clientQueueMax[0].queueContactname !== " " ? convertUnicodeEmoji(clientQueueMax[0].queueContactname):clientQueueMax[0].queueCaller
                            :
                            ""
                        }
                    </p>
                    <i className="material-icons anotc__icon">note</i>{" "}
                    <span className="anotc__info-text">
                        Total de{" "}
                        <span className="anotc__counter">
                        {anotationsData.length}
                        </span>{" "}
                        anotações
                    </span>
                    </div>
                    <div className="anotc__wrapper">
                    <div className="anotc__mp">
                        <div className="anotc__mp-ctrL">
                        <div className="anotc__mp-date">
                            <p className="anotc__mp-date-text">
                            Deseja buscar as anotação de qual período?
                            </p>
                            <div className="anotc__mp-date-wrapper">
                            <span className="anotc__mp-date-span">De:</span>
                            <input
                                type="date"
                                className="anotc__mp-date-start"
                                id="date_init_search"
                                defaultValue={dateinitsearchanotation}
                            />
                            <span className="anotc__mp-date-span">Até:</span>
                            <input
                                type="date"
                                className="anotc__mp-date-end"
                                id="date_fim_search"
                                defaultValue={dateendsearchanotation}
                            />
                            </div>
                        </div>
                        <div className="anotc__mp-critic">
                            <p className="anotc__mp-critic-text">
                            E com qual nível de criticidade?
                            </p>
                            <div className="anotc__mp-critic-wrapper">
                            <button
                                className="anotc__mp-critic-btn"
                                onClick={() => setVisibleCritic(!visibleCritic)}
                            >
                                {criticSelected.length !== 0 ? 
                                (
                                    criticSelected[0].critSelec
                                )
                                :""}
                                <i className="anotc__mp-critic-icon material-icons">
                                keyboard_arrow_down
                                </i>
                            </button>
                            <div
                                className={
                                visibleCritic
                                    ? "anotc__mp-critic-options active"
                                    : "anotc__mp-critic-options"
                                }
                            >
                                <ul className="anotc__mp-critic-list" style={{height: '300px', overflowY: 'auto'}}>
                                <li
                                    className="anotc__mp-critic-item"
                                    onClick={() => SelectCriticitys(
                                      "Todos",
                                      "",
                                      ""
                                    )}
                                >
                                    <span className="anotc__mp-critic-dot">•</span>
                                    Todos
                                </li>
                                {criticData.map(desc => (
                                    <li
                                    key={desc.id}
                                    className="anotc__mp-critic-item"
                                    onClick={() => SelectCriticitys(
                                        desc.description,
                                        desc.id,
                                        desc.class_criticality
                                    )}
                                    >
                                    <span
                                        className={
                                        "anotc__mp-critic-dot " +
                                        desc.class_criticality
                                        }
                                    >
                                        •
                                    </span>
                                    {desc.description}
                                    </li>
                                ))}
                                </ul>
                            </div>
                            </div>
                        </div>
                        <button
                            className="anotc__mp-btn"
                            onClick={event => buttonSearchAnotation(event)}
                        >
                            Filtrar
                        </button>
                        </div>

                        <div className="anotc__mp-result">
                        <div className="anotc__mp-search">
                            <span className="material-icons anotc__mp-search-icon">
                            expand_less
                            </span>
                            <span className="material-icons anotc__mp-search-icon">
                            expand_more
                            </span>
                            <input
                            type="text"
                            className="anotc__mp-search-input"
                            placeholder="Pesquisar..."
                            />
                            <button className="anotc__mp-search-btn">
                            Concluir
                            </button>
                        </div>

                        <ul className="anotc__mp-result-list">
                            {anotData.map(details => (
                            <li
                                key={details.id}
                                className="anotc__mp-result-item"
                            >
                                <button className="anotc__mp-result-avatar">
                                    <img src="build/images/cliente.svg" alt="" />
                                </button>
                                <a
                                href="#"
                                className="anotc__mp-result-btn"
                                onClick={event =>
                                    checkExpandLearnQueue(event, details.id)
                                }
                                >
                                <span className="anotc__mp-result-span material-icons">
                                    {buttonLearnMore ||
                                    expandLearn.indexOf(details.id) !=
                                    -1
                                    ? "remove_circle_outline"
                                    : "add_circle_outline"}
                                </span>
                                <span
                                    className={
                                    buttonLearnMore ||
                                    expandLearn.indexOf(details.id) !=
                                        -1
                                        ? "hack"
                                        : "hack active"
                                    }
                                >
                                    {" "}
                                    Leia mais
                                </span>
                                <span
                                    className={
                                    buttonLearnMore ||
                                    expandLearn.indexOf(details.id) !=
                                        -1
                                        ? "hack active"
                                        : "hack"
                                    }
                                >
                                    {" "}
                                    Leia menos
                                </span>
                                </a>
                                <div className="anotc__mp-result-item-top">
                                <div className="anotc__mp-result-item-info">
                                    <p className="anotc__mp-result-item-name">
                                    {clientQueueMax.length !== 0 ? 
                                        clientQueueMax[0].queueContactname !== " " ? convertUnicodeEmoji(clientQueueMax[0].queueContactname):clientQueueMax[0].queueCaller
                                        :
                                        ""
                                    }
                                    </p>
                                    <p className="anotc__mp-result-item-title">
                                    {details.usuario_anotacao}
                                    </p>
                                </div>
                                <div className="anotc__mp-result-item-critic">
                                    <span
                                    className={
                                        "anotc__mp-result-item-level " +
                                        details.class_criticality
                                    }
                                    >
                                    {details.desc_criticidade}
                                    </span>
                                    <span className="anotc__mp-result-item-fulltime">
                                    {details.data_anotacao +
                                        " - " +
                                        details.hora_anotacao}
                                    </span>
                                </div>
                                </div>
                                <div
                                className={
                                    buttonLearnMore ||
                                    expandLearn.indexOf(details.id) !=
                                    -1
                                    ? "anotc__mp-result-item-content auto"
                                    : "anotc__mp-result-item-content"
                                }
                                >
                                {details.desc_anotacao}
                                </div>
                            </li>
                            ))}
                        </ul>
                        </div>
                    </div>
                    </div>

                    {/* <div className="flab">
                    <a href="#" className="flab__button">
                        <div className="material-icons">add</div>
                    </a>
                    <div className="flab__related">
                        <a
                        href="#"
                        className="btn--add-anotc flab__related__button tippy-default"
                        data-tippy-content="Adicionar uma anotação"
                        data-tippy-theme="light"
                        data-tippy-placement="left"
                        >
                        <div className="material-icons">note_add</div>
                        </a>
                        <a
                        href="#"
                        className="btn--search-anotc flab__related__button tippy-default"
                        data-tippy-content="Adicionar em uma anotação"
                        data-tippy-theme="light"
                        data-tippy-placement="left"
                        >
                        <div className="material-icons">search</div>
                        </a>
                    </div>
                    <div className="flab__overlay"></div>
                    </div> */}
                </main>
                </div>
            </div>
            </div>
    );
}